.content {
  display: flex;
  flex-direction: row;
  max-height: calc(100% - 8rem);
  flex: 1;
  max-width: 100vw;
}

.overlay-wrapper {
  position: absolute;
}

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  overflow-y: scroll;
}

.drawer {
  border-left: 1px var(--content-border-color) solid;
  width: 36rem;
  display: flex;
  flex-direction: column;
}
